module.exports = __webpack_public_path__ + "static/media/rodrigo_profile_picture.39873869.png";